module.exports = __webpack_public_path__ + "static/media/cover.4eb85c79.png";